import TeacherApi from './TeacherApi';
export default TeacherApi;
